module.exports = __webpack_public_path__ + "static/Sun_Smart_Approved_Logo-efd8e2c40b750d6def9e821446f6be19.png";